import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import AOS from 'aos';
import 'aos/dist/aos.css';

import "./slider.css";

// Images (replace with actual ones)
import necklace1 from "../../Assets/images/Jewellery/j1.png";
import necklace2 from "../../Assets/images/Jewellery/j2.png";
import necklace3 from "../../Assets/images/Jewellery/j3.png";

import bangle1 from "../../Assets/images/Jewellery/b1.png";
import bangle2 from "../../Assets/images/Jewellery/b2.png";
import bangle3 from "../../Assets/images/Jewellery/b3.png";

import ring1 from "../../Assets/images/Jewellery/e1.png";
import ring2 from "../../Assets/images/Jewellery/e2.png";
import ring3 from "../../Assets/images/Jewellery/e3.png";

import watch1 from "../../Assets/images/Jewellery/w1.png";
import watch2 from "../../Assets/images/Jewellery/w2.png";
import watch3 from "../../Assets/images/Jewellery/w3.png";

import taimg1 from "../../Assets/images/articles/t1.png";
import taimg2 from "../../Assets/images/articles/t2.png";
import taimg3 from "../../Assets/images/articles/t3.png";

import wtimg1 from "../../Assets/images/articles/wt1.png";
import wtimg2 from "../../Assets/images/articles/wt2.png";
import wtimg3 from "../../Assets/images/articles/wt3.png";

import d1 from "../../Assets/images/articles/d1.png";
import d2 from "../../Assets/images/articles/d2.png";
import d3 from "../../Assets/images/articles/d3.png";

const JewelleryShowcase = () => {
  const location = useLocation();
  const isArticlesPage = location.pathname.includes("articles");

  const [selectedImage, setSelectedImage] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 3000, once: true });
  }, []);

  const openModal = (imgSrc) => {
    setSelectedImage(imgSrc);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedImage(null);
    setIsModalOpen(false);
  };

  const necklaceSet = [necklace1, necklace2, necklace3];
  const banglesSet = [bangle1, bangle2, bangle3];
  const ringsSet = [ring1, ring2, ring3];
  const watches = [watch1, watch2, watch3];
  const traditionalarticles = [taimg1, taimg2, taimg3];
  const whisperaoftraditon = [wtimg1, wtimg2, wtimg3];
  const divine = [d1, d2, d3];

  const animationTypes = ["fade-up", "zoom-in", "fade-down", "fade-up", "fade-right", "fade-down"];

  const renderSection = (title, images) => (
    <div className="jewellery-section" data-aos="fade-up">
      <h2 className="section-title">{title}</h2>
      <div className="jewellery-items-wrapper">
        {images.map((img, index) => (
          <img
            key={index}
            src={img}
            alt={`${title}-${index}`}
            data-aos={animationTypes[index % animationTypes.length]}
            onClick={() => openModal(img)}
            className="jewellery-img"
          />
        ))}
      </div>
    </div>
  );

  return (
    <div className="static-slider-wrapper">
      {isModalOpen && (
        <div className="image-modal">
          <span className="close-button" onClick={closeModal}>&times;</span>
          <img src={selectedImage} alt="Enlarged View" className="modal-image" />
        </div>
      )}

      {isArticlesPage ? (
        <>
          {renderSection("Traditional Articles", traditionalarticles)}
          {renderSection("Whispers of Tradition", whisperaoftraditon)}
          {renderSection("Divine", divine)}
        </>
      ) : (
        <>
          {renderSection("Necklace Sets", necklaceSet)}
          {renderSection("Bangles & Bracelets", banglesSet)}
          {renderSection("Rings", ringsSet)}
          {renderSection("Watches", watches)}
        </>
      )}
    </div>
  );
};

export default JewelleryShowcase;
